/* Microscope sections: zoom lens demo + single-open FAQ accordion. Re-inits inside the Theme Editor. */
(function () {
  function initLens(root) {
    root.querySelectorAll('[data-mm-lens]').forEach(function (box) {
      if (box.dataset.mmReady) return;
      box.dataset.mmReady = '1';
      var range = box.querySelector('[data-mm-range]');
      var target = box.querySelector('[data-mm-target]');
      var badge = box.querySelector('[data-mm-badge]');
      if (!range || !target) return;
      var min = parseFloat(box.dataset.minZoom) || 25;
      var max = parseFloat(box.dataset.maxZoom) || 250;
      var steps = parseInt(range.max, 10) || 10;
      function update() {
        var v = parseInt(range.value, 10) || 1;
        var pct = steps > 1 ? (v - 1) / (steps - 1) : 0;
        var zoom = Math.round(min + (max - min) * pct);
        target.style.transform = 'scale(' + (0.6 + pct * 5.4).toFixed(2) + ')';
        if (badge) badge.textContent = zoom + 'x';
        range.setAttribute('aria-valuetext', zoom + 'x magnification');
      }
      range.addEventListener('input', update);
      update();
    });
  }
  function initFaq(root) {
    root.querySelectorAll('[data-mm-accordion]').forEach(function (wrap) {
      if (wrap.dataset.mmReady) return;
      wrap.dataset.mmReady = '1';
      wrap.addEventListener('toggle', function (e) {
        if (!e.target.open) return;
        wrap.querySelectorAll('details').forEach(function (d) { if (d !== e.target) d.open = false; });
      }, true);
    });
  }
  function init(root) { initLens(root || document); initFaq(root || document); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
